import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HistoryPage from "../pages/history/page";
import CouponsPage from "../pages/coupons/page";
import LoginPage from "../pages/login/page";
import RegisterPage from "../pages/register/page";
import StaffPage from "../pages/staff/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import ProtectedRoute from "../components/ProtectedRoute";

const routes: RouteObject[] = [
  { path: "/login", element: <LoginPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/privacy", element: <PrivacyPage /> },
  { path: "/staff", element: <StaffPage /> },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    ),
  },
  {
    path: "/coupons",
    element: (
      <ProtectedRoute>
        <CouponsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/history",
    element: (
      <ProtectedRoute>
        <HistoryPage />
      </ProtectedRoute>
    ),
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
